module.exports = __webpack_public_path__ + "img/Support-skill-627.e6d2762a.png";